import { ItemProperties } from '../../types';

// A configuration's name lives in a single text field (display_name "First
// Name") whose value packs first + last name separated by a newline - see
// getConfigLabel (ConfigSessionSwitcher) for how it's split for display.
export function getConfigNameValue(
  properties: ItemProperties | undefined
): string | undefined {
  if (!properties) return undefined;
  const nameField = Object.values(properties.fields).find(
    field => field.display_name === 'First Name'
  );
  return nameField?.value;
}
